import React, { useState, useContext } from "react";
import Box from "../../box";
import styled from "styled-components";
import Img from "gatsby-image";
import { ProductContext } from "../product-context";

const Title = styled.h2`
  font-size: ${p => p.theme.fontSizes[2]}px;
  text-align: center;

  @media screen and (min-width: ${p => p.theme.breakpoints[1]}px) {
    font-size: ${p => p.theme.fontSizes[3]}px;
  }
`;

const Total = styled.div`
  color: ${props => props.theme.colors.rojoBac};
  font-size: ${p => p.theme.fontSizes[6]}px;

  &:before {
    content: "=";
    color: ${props => props.theme.colors.grisMedio};
    margin-right: 10px;
  }
`;

const RadioBoxLabel = styled.label`
  padding: ${props => props.theme.space[2]}px;
  display: flex;
  box-shadow: ${props => (props.selected ? props.theme.shadows[1] : "none")};
  border-radius: ${props => props.theme.radii[2]}px;
  justify-content: left;
  align-items: center;

  &:before {
    content: "";
    display: inline-block;
    margin-right: 10px;
    width: 0.9em;
    height: 0.9em;
    border-radius: 50%;
    background: ${props =>
      props.selected ? props.theme.colors.rojoBac : props.theme.colors.blanco};
    border: 1px solid
      ${props =>
        props.selected
          ? props.theme.colors.blanco
          : props.theme.colors.grisClaro};
  }

  input {
    display: none;
  }
`;

const ColorBtn = styled.label`
  box-shadow: ${p => (p.selected ? p.theme.shadows[1] : `none`)};
  padding: ${props => props.theme.space[3]}px;
  border-radius: ${props => props.theme.radii[2]}px;
  position: relative;

  .titulo {
    display: block;
    margin-top: ${props => props.theme.space[2]}px;
  }

  input {
    display: none;
  }

  &:before {
    content: "";
    display: block;
    position: absolute;
    bottom: ${props => props.theme.space[2]}px;
    right: ${props => props.theme.space[2]}px;
    width: 0.9em;
    height: 0.9em;
    border-radius: 50%;
    background: ${props =>
      props.selected ? props.theme.colors.rojoBac : props.theme.colors.blanco};
    border: 1px solid
      ${props =>
        props.selected
          ? props.theme.colors.blanco
          : props.theme.colors.grisClaro};
  }
`;

const s = 4;

const Paso = ({ num, titulo }) => (
  <Box py={4}>
    <strong>{num}</strong> {titulo}
  </Box>
);

const Calculadora = ({
  colores: coloresIniciales
}) => {
  const valores = {
    Dorado: {
      millasIniciales: 2000,
      premios: {
        2: { monto: 1000, premio: 3000 },
        5: { monto: 3000, premio: 3000 },
        8: { monto: 5000, premio: 3000 }
      }
    },
    Platino: {
      millasIniciales: 5000,
      premios: {
        2: { monto: 2000, premio: 5000 },
        5: { monto: 6000, premio: 5000 },
        8: { monto: 9000, premio: 5000 }
      }
    },
    Black: {
      millasIniciales: 10000,
      premios: {
        2: { monto: 3000, premio: 10000 },
        5: { monto: 6000, premio: 5000 },
        8: { monto: 9000, premio: 5000 }
      }
    }
  };

  const colores = coloresIniciales.map(color => ({
    ...color,
    ...valores[color.titulo]
  }));

  const plazos = [2, 5, 8];

  // State management
  const { selectedColorKey, setSelectedColorKey } = useContext(
    ProductContext
  );
  const [selectedReto, setSelectedReto] = useState(2);
  const selectedColor = colores[selectedColorKey];
  const total =
    selectedColor.millasIniciales +
    selectedColor["premios"][selectedReto]["premio"] +
    1500;

  return (
    <div id="calculadora">
      <Title>Calculá cuantas millas podés ganar</Title>
      <Box
        maxWidth={600}
        boxShadow={1}
        borderRadius={2}
        bg="blanco"
        className="panel"
        mx={[3, "auto"]}
      >
        <Box px={4}>
          <Paso num={1} titulo="Seleccioná un color de tarjeta" />
          <div
            style={{
              display: "grid",
              gridTemplateColumns: `repeat(3,1fr)`
            }}
          >
            {colores.map((color, i) => (
              <ColorBtn key={color.id + i} selected={color.selected}>
                <Img fluid={color.arte.fluid} alt={color.titulo} />
                <input
                  type="radio"
                  value={color.variacion}
                  id="color-switch-calculadora"
                  name="color-switch-calculadora"
                  onChange={() => setSelectedColorKey(i)}
                  checked={color.selected}
                />
                <div className="titulo">{color.titulo}</div>
                <small>+{color.millasIniciales} millas de bienvenida</small>
              </ColorBtn>
            ))}
          </div>
          <div><Paso titulo="* Millas de bienvenida aplican después de facturar $100." /></div>
          <Paso num={2} titulo="Seleccioná un reto de facturación" />
          <div>
            {plazos.map(plazo => (
              <RadioBoxLabel
                key={`plazo-${plazo}`}
                selected={selectedReto === plazo}
              >
                <input
                  type="radio"
                  value={plazo}
                  id="reto-switch-calculadora"
                  name="reto-switch-calculadora"
                  onChange={() => setSelectedReto(plazo)}
                  defaultChecked={selectedReto === plazo}
                />
                <div>
                  Facturar ${selectedColor.premios[plazo]["monto"]} en {plazo}{" "}
                  meses
                  <br />
                  <small>+{selectedColor.premios[plazo]["premio"]}</small>
                </div>
              </RadioBoxLabel>
            ))}
          </div>
          <Paso num={3} titulo="Obtené +1500 por solicitarla en línea" />
        </Box>
        <Box bg="grisDeFondo" p={s} style={{ textAlign: "right" }}>
          <Total>{total}</Total>
          Millas LifeMiles
        </Box>
      </Box>
    </div>
  );
};

export default Calculadora;
